import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage
} from '@react-pdf/renderer';

/* 🔹 STYLES */
const styles = StyleSheet.create({
    page: {
        position: 'relative'
    },

    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },

    /* 🔹 FIELD POSITIONS (ADJUST IF NEEDED) */

    serial: {
        position: 'absolute',
        top: 85,     // थोड़ा ऊपर (adjust if needed)
        right: 100,   // right aligned
        fontSize: 15
    },

    name: {
        position: 'absolute',
        top: 115,
        left: 95,
        fontSize: 10
    },

    ageSex: {
        position: 'absolute',
        top: 115,
        left: 290,
        fontSize: 8
    },

    date: {
        position: 'absolute',
        top: 115,
        left: 400,
        fontSize: 10
    },

    uhid: {
        position: 'absolute',
        top: 115,
        left: 520,
        fontSize: 10
    },

    guardian: {
        position: 'absolute',
        top: 140,
        left: 200,
        fontSize: 10
    },

    phone: {
        position: 'absolute',
        top: 140,
        left: 480,
        fontSize: 10
    },

    address: {
        position: 'absolute',
        top: 163,
        left: 100,
        right: 40,
        fontSize: 10
    }
});

/* 🔹 MAIN COMPONENT */
export const PatientRegistrationPdf23 = ({ data }) => {
    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    return (
        <PDFViewer width="100%" height="100%">
            <Document>
                <PDFPage size="A4" style={styles.page}>

                    {/* ✅ BACKGROUND TEMPLATE */}
                    <PDFImage
                        src={`${window.location.origin}/PDf Print Format.png`}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }}
                        fixed
                    />

                    {/* ✅ OVERLAY VALUES */}
                    <PDFView style={styles.container}>

                        <PDFText style={styles.serial}>
                            {data?.token_no || ''}
                        </PDFText>

                        <PDFText style={styles.name}>
                            {data?.name || ''}
                        </PDFText>

                        <PDFText style={styles.ageSex}>
                            {data?.age || ''}/{data?.gender || ''}
                        </PDFText>

                        <PDFText style={styles.date}>
                            {formatDate(data?.reg_date)}
                        </PDFText>

                        <PDFText style={styles.uhid}>
                            {data?.uhid || ''}
                        </PDFText>

                        <PDFText style={styles.guardian}>
                            {data?.guardian_name || ''}
                        </PDFText>

                        <PDFText style={styles.phone}>
                            {data?.mobile || ''}
                        </PDFText>

                        <PDFText style={styles.address}>
                            {data?.address || ''}
                        </PDFText>

                    </PDFView>

                </PDFPage>
            </Document>
        </PDFViewer>
    );
};